"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.Titlebar = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _styles = require("@material-ui/core/styles");

var _withWidth = _interopRequireDefault(require("@material-ui/core/withWidth"));

var _classnames = _interopRequireDefault(require("classnames"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireWildcard(require("react"));

var _reactDocumentTitle = _interopRequireDefault(require("react-document-title"));

var _Breadcrumbs = _interopRequireDefault(require("../Breadcrumbs/Breadcrumbs"));

var _ButtonGroup = _interopRequireDefault(require("../ButtonGroup"));

var _Grid = _interopRequireDefault(require("../Grid"));

var _styles2 = require("./styles");

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var Titlebar = /*#__PURE__*/function (_Component) {
  (0, _inherits2.default)(Titlebar, _Component);

  var _super = _createSuper(Titlebar);

  function Titlebar() {
    var _this;

    (0, _classCallCheck2.default)(this, Titlebar);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "render", function () {
      var _this$props = _this.props,
          id = _this$props.id,
          title = _this$props.title,
          description = _this$props.description,
          breadcrumbs = _this$props.breadcrumbs,
          maxItems = _this$props.maxItems,
          buttons = _this$props.buttons,
          className = _this$props.className,
          classes = _this$props.classes,
          width = _this$props.width,
          buttonRef = _this$props.buttonRef,
          theme = _this$props.theme,
          ButtonGroupProps = _this$props.ButtonGroupProps;
      return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, theme && theme.title ? /*#__PURE__*/_react.default.createElement(_reactDocumentTitle.default, {
        title: "".concat(title, " \u2022 ").concat(theme.title)
      }) : null, /*#__PURE__*/_react.default.createElement(_Grid.default, {
        container: true,
        spacing: 1,
        id: id,
        className: (0, _classnames.default)("prmbl-titlebar", className, classes.root)
      }, breadcrumbs && /*#__PURE__*/_react.default.createElement(_Grid.default, {
        item: true,
        xs: 12
      }, /*#__PURE__*/_react.default.createElement(_Breadcrumbs.default, {
        id: id + "-breadcrumbs",
        className: "titlebar-breadcrumbs",
        maxItems: maxItems
      }, [].concat((0, _toConsumableArray2.default)(breadcrumbs), [/*#__PURE__*/_react.default.createElement("span", {
        key: "self"
      }, title)]))), (title || description) && /*#__PURE__*/_react.default.createElement(_Grid.default, {
        item: true,
        xs: 12,
        md: buttons || buttonRef ? 7 : 12
      }, title && /*#__PURE__*/_react.default.createElement("h1", {
        className: (0, _classnames.default)("titlebar-title", classes.title)
      }, title), description && /*#__PURE__*/_react.default.createElement("p", {
        className: (0, _classnames.default)("titlebar-description", classes.description),
        id: id + "-description"
      }, description)), (buttons || buttonRef) && /*#__PURE__*/_react.default.createElement(_Grid.default, {
        item: true,
        xs: 12,
        md: title || description ? 5 : 12
      }, buttonRef ? /*#__PURE__*/_react.default.createElement("span", {
        ref: buttonRef
      }) : /*#__PURE__*/_react.default.createElement(_ButtonGroup.default, (0, _extends2.default)({
        layout: width === "xs" ? "justify" : width === "sm" ? "left" : "right",
        className: "titlebar-buttons",
        id: id + "-buttons"
      }, ButtonGroupProps), buttons))));
    });
    return _this;
  }

  return Titlebar;
}(_react.Component);

exports.Titlebar = Titlebar;
(0, _defineProperty2.default)(Titlebar, "propTypes", {
  /**
   * The html id
   */
  id: _propTypes.default.string,

  /**
   * The title text
   */
  title: _propTypes.default.string,

  /**
   * The description text
   */
  description: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.node]),

  /**
   * 	Pass in multiple children. Each child will become a separate breadcrumb.
   */
  breadcrumbs: _propTypes.default.node,

  /**
   * Specifies the maximum number of breadcrumbs to display. When there are more than the maximum number, only the first and last will be shown, with an ellipsis in between.
   */
  maxItems: _propTypes.default.node,

  /**
   * Pass in multiple buttons.
   */
  buttons: _propTypes.default.node,

  /**
   * @ignore
   */
  className: _propTypes.default.string,

  /**
   * @ignore
   *
   * Utilizing this to style up the page don't want to expose this in the style guide.
   * Auto-populated by material-ui withStyles()
   */
  classes: _propTypes.default.object.isRequired,

  /**
   * @ignore
   */
  width: _propTypes.default.string,

  /**
   * If provided, passes a ref to allow dynamic button creation
   */
  buttonRef: _propTypes.default.oneOfType([_propTypes.default.func, _propTypes.default.shape({
    current: _propTypes.default.element
  })]),

  /**
   * @ignore
   */
  theme: _propTypes.default.object,

  /**
   * Props to spread to the ButtonGroup
   */
  ButtonGroupProps: _propTypes.default.object
});
(0, _defineProperty2.default)(Titlebar, "defaultProps", {
  id: "titlebar",
  className: "",
  maxItems: 8,
  width: ""
});

var _default = (0, _withWidth.default)()((0, _styles.withStyles)(_styles2.styles)((0, _styles.withTheme)(Titlebar)));

exports.default = _default;